import gql from "graphql-tag";

export const GET_PACKAGE_SETTINGS = gql`
query getPackageSettings{
 packageSettings: Settings(where:{key:{_eq:"packTypeColor"}}){
  id
  key         
  value
 }
}`